import type { NskResponse } from '~/models/Api';
import { putRequest } from '../api_handler';

const paths = {
  update: '/vendors/deal_visit_dates/:id'
};

export const update = async (
  dealId: number,
  inspectionDate: Date | null,
  surveyDate: Date | null,
  vendorUserId: number | null
): Promise<NskResponse<void>> =>
  putRequest(paths.update.replace(':id', String(dealId)), {
    inspectionDate,
    surveyDate,
    vendorUserId
  });
